import * as React from "react";
import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import stageTimeImageOne from "../../images/stage-times/all.jpg";
import stageTimeImageTwo from "../../images/stage-times/map.jpg";
import stageTimeImageThree from "../../images/stage-times/timetable.jpg";
import stageTimeImageFour from "../../images/stage-times/com.jpg";
import QRCodeImage from "../../images/stage-times/qr.png";

import stageTime1 from "../../images/assets/INSTA STAGE TIMES-01.jpg";
import stageTime2 from "../../images/assets/INSTA STAGE TIMES-02.jpg";
import stageTime3 from "../../images/assets/INSTA STAGE TIMES-03.jpg";
import stageTime4 from "../../images/assets/INSTA STAGE TIMES-04.jpg";
import stageTime5 from "../../images/assets/INSTA STAGE TIMES-05.jpg";
import stageTime6 from "../../images/assets/INSTA STAGE TIMES part 2-01.jpg";
import stageTime7 from "../../images/assets/INSTA STAGE TIMES part 2-02.jpg";
import stageTime8 from "../../images/assets/INSTA STAGE TIMES part 2-03.jpg";
import stageTime9 from "../../images/assets/INSTA STAGE TIMES part 2-04.jpg";
import stageTime10 from "../../images/assets/INSTA STAGE TIMES part 2-05.jpg";
import stageTime11 from "../../images/assets/INSTA STAGE TIMES part 2-06.jpg";
import stageTime12 from "../../images/assets/INSTA STAGE TIMES part 2-07.jpg";

function StageTimes() {
  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content stage-times-content">
        <div className="text-section">
          <Typography className="title film-title" variant="h6">
            FREE Manchester Psych Fest 2026 App via WOOV.
          </Typography>
        </div>
        <div className="text-section">
          <Typography className="text venue-title">
            Download the app for:
          </Typography>
          <Typography className="text">
            ⌚️ Full venue splits and stage times which you can personalise and
            plan your day.
          </Typography>
          <Typography className="text">🧭 3D map of the whole site.</Typography>
          <Typography className="text">
            🗣️ Chat to other festival goers in the community section.
          </Typography>
          <Typography className="text">
            🤫 We’ll also send out messages via the app including our secret
            sets @theabbey
          </Typography>
          <Typography className="text">
            Available from the link OR scan the QR code.
            <a
              href="https://woov.to/manchesterpsychfest26"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              https://woov.to/manchesterpsychfest26
            </a>
          </Typography>
        </div>
        <div className="qr-code">
          <img src={QRCodeImage} alt="stage-times-qr" />
        </div>

        <div className="stage-times-images">
          <div className="stage-times-image">
            <img src={stageTimeImageOne} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            {" "}
            <img src={stageTimeImageTwo} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            {" "}
            <img src={stageTimeImageThree} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            <img src={stageTimeImageFour} alt="stage-times" />
          </div>
        </div>

        <div className="stage-times-images">
          <div className="stage-times-image">
            <img src={stageTime1} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            {" "}
            <img src={stageTime2} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            {" "}
            <img src={stageTime3} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            <img src={stageTime4} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            {" "}
            <img src={stageTime5} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            <img src={stageTime6} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            {" "}
            <img src={stageTime7} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            <img src={stageTime8} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            {" "}
            <img src={stageTime9} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            <img src={stageTime10} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            {" "}
            <img src={stageTime11} alt="stage-times" />
          </div>
          <div className="stage-times-image">
            <img src={stageTime12} alt="stage-times" />
          </div>
        </div>

        <div className="text-section">
          <Typography className="title" variant="h6">
            Contact
          </Typography>
          <Typography className="text">info@manchesterpsychfest.com</Typography>
        </div>
      </div>
    </Container>
  );
}
export default StageTimes;
